"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getRoutes;
const native_1 = require("@react-navigation/native");
const discoverRoutes_1 = __importDefault(require("./discoverRoutes"));
const mobileRoutes_1 = __importDefault(require("./mobileRoutes"));
const deniedParamsRoutes_1 = __importDefault(require("./deniedParamsRoutes"));
const SEARCH_PARAMS_REGEX = /\?.*$/;
const getCurrentRoute = (state) => {
    const currentRoute = state.routes[state.index ?? 0];
    return currentRoute.state
        ? getCurrentRoute(currentRoute.state)
        : currentRoute;
};
const getCurrentConfigScreen = (state, options) => {
    const currentRoute = state.routes[state.index ?? 0];
    const currentConfigScreen = options.screens[currentRoute.name];
    if (!currentConfigScreen) {
        return null;
    }
    ;
    return typeof currentConfigScreen === 'string'
        ? currentConfigScreen
        : getCurrentConfigScreen(currentRoute.state, currentConfigScreen);
};
const getParamsRegex = (numberOfParams) => new RegExp(`(/[^/]+){${numberOfParams}}$`);
function getRoutes({ isMobile } = {}) {
    const { Home: { screens: mobileDiscoverRoutes }, ...restMobileRoutes } = mobileRoutes_1.default;
    const config = {
        screens: {
            Home: {
                screens: isMobile ? mobileDiscoverRoutes : discoverRoutes_1.default,
            },
            Summary: 'Summary/:conversationId?/:shareId?/:openChat?/:autoMessage?',
            LoginPage: 'login',
            ConfigurePrompts: 'prompts-master',
            // MacOSWidget: 'AddSources',
            ...(isMobile && restMobileRoutes),
        },
    };
    return {
        prefixes: [],
        config,
        getStateFromPath: (path, options) => {
            const chatSummaryPath = '/Summary/Chat';
            if (!isMobile && path.startsWith(chatSummaryPath)) {
                return (0, native_1.getStateFromPath)(`${path.replace('/Chat', '')}`, options);
            }
            return (0, native_1.getStateFromPath)(path, options);
        },
        getPathFromState(state, options) {
            const optionalParamsRegex = /(?<=:.+\?).+/;
            const navigationUrl = (0, native_1.getPathFromState)(state, options);
            const currentRoute = getCurrentRoute(state);
            const currentConfigScreen = getCurrentConfigScreen(state, options);
            if (deniedParamsRoutes_1.default.has(currentRoute.name)) {
                return navigationUrl.replace(SEARCH_PARAMS_REGEX, '');
            }
            ;
            if (currentConfigScreen) {
                const configSearchParams = (currentConfigScreen
                    .match(optionalParamsRegex)?.[0]
                    .replace(':', '')
                    .replace('?', '')
                    .split('/'));
                const stateSearchParams = (Object.entries(currentRoute.params ?? {}).filter(([paramKey]) => (configSearchParams?.includes(paramKey))));
                const urlWithoutSearch = (navigationUrl.replace(getParamsRegex(stateSearchParams.length), ''));
                return stateSearchParams.reduce((url, [paramKey, paramValue], index, paramsArray) => (`${url}${paramKey}=${paramValue}${index === paramsArray.length - 1 ? '' : '&'}`), `${urlWithoutSearch}${stateSearchParams.length ? '?' : ''}`);
            }
            ;
            return navigationUrl;
        },
    };
}
